import React from 'react'

const MakerCell = ({row}) => {
  return (
    <div>{row?.maker?.makerName}</div>
  )
}

export default MakerCell